@if (showCard()) {

<!--NORMAL NON-TC-->
@if (type() === 'normal' && !cardForTC() && !hasPreselecta()) {
<div class="tab" [ngClass]="[labelConfig().color, labelConfig().showLabel ? 'tab--with-badge' : '']">
  <div class="tab-title-window" [class.tab-title-window--marquee]="tabTitleIsLong()">
    <h2 class="txtTab"><span>{{ tabTitle() }}</span></h2>
  </div>
  @if (labelConfig().showLabel) {
  <img class="tab-badge-icon" [src]="labelConfig().img" [alt]="offer().textLabel" [title]="offer().textLabel" />
  }
</div>
<div class="box-card col-12" [id]="'offer' + labelId()" [ngClass]="'border-' + labelConfig().color">
  <div class="row">
    <p class="id-offer-hidden">{{ offer().idOffer }}</p>
    <div class="col-12">
      @if (labelConfig().showLabel) {
      <!-- <div class="icon-pay col-12">
        <app-ui-sponsor-badge class="sponsor-badge-slot" [variant]="labelConfig().color"
          [label]="offer().textLabel.slice(0,20)" />
      </div> -->
      }
      <div class="main-info row align-items-center"     
        [class.main-info--without-benefit]="!hasAdditionalBenefits()">
        <div class="col-md-4 col-12">
          <div class="section-1">
            <div>
              <app-offer-media [logoUrl]="logoUrl()" [companyName]="offer().company.name"
                [productName]="offer().card.productName" />
            </div>
          </div>
        </div>
        <div class="col-md-8 col-12 card-offer__info-col">
          <app-offer-info-molecule [receiveValue]="offer().card.offerValue ?? ''"
            [detail1Title]="offer().card.offerDetail1" [detail1Value]="offer().card.offerDetail1value"
            [approxTitle]="offer().card.offerAproxValueTitle ?? ''" [captionValue]="offer().card.offerAproxValue ?? ''"
            [additionalBenefits]="false" />
        </div>
      </div>
      <div class="card-lower-content">
      <div class="card-benefit-row" [class.card-benefit-row--empty]="!hasAdditionalBenefits()">
        @if (hasAdditionalBenefits()) {
        <app-ui-benefit-badge
          [showCrown]="false"
          [text]="offer().detail.textAdditionalBenefits ?? ''" />
        }
      </div>
      <div class="card-actions">
        <button class="card-actions__details" type="button" (click)="detailPressed.emit()">
          Ver más detalles <span>+</span>
        </button>
        @if (buttonState() === 1) {
        <button class="btn-cta" type="button" (click)="applyPressed.emit()">
          Aplicar ahora<i class="fa fa-chevron-right"></i>
        </button>
        }
        @if (buttonState() === 2 && !continueLoading()) {
        <button (click)="retryPressed.emit()" class="btn-cta blue">Retomar aplicación<i class="fa fa-chevron-right"></i></button>
        }
        @if (buttonState() === 2 && continueLoading()) {
        <button class="btn-cta blue spinner-btn"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>
        }
        @if (buttonState() === 3) {
        <button class="btn-cta">Oferta aplicada</button>
        }
      </div>
      </div>
    </div>
  </div>
</div>
}
<!--/NORMAL NON-TC-->

<!--NORMAL TC-->
@if (type() === 'normal' && cardForTC() && !hasPreselecta()) {
<div class="tab" [ngClass]="[labelConfig().color, labelConfig().showLabel ? 'tab--with-badge' : '']">
  <div class="tab-title-window" [class.tab-title-window--marquee]="tabTitleIsLong()">
    <h2 class="txtTab"><span>{{ tabTitle() }}</span></h2>
  </div>
  @if (labelConfig().showLabel) {
  <img class="tab-badge-icon" [src]="labelConfig().img" [alt]="offer().textLabel" [title]="offer().textLabel" />
  }
</div>
<div class="box-card box-tc col-12" [id]="'offer' + labelId()" [ngClass]="'border-' + labelConfig().color">
  <div class="row">
    <p class="id-offer-hidden">{{ offer().idOffer }}</p>
    <div class="col-12">
      @if (labelConfig().showLabel) {
      <!-- <div class="icon-pay col-12">
        <app-ui-sponsor-badge class="sponsor-badge-slot" [variant]="labelConfig().color"
          [label]="offer().textLabel.slice(0,20)" />
      </div> -->
      }
      <div class="main-info row align-items-center"
      [class.main-info--without-benefit]="!hasAdditionalBenefits()">
        <div class="col-md-4 col-12">
          <div class="section-1">
            <div class="tc-media-slot">
              <app-offer-media [logoUrl]="logoUrl()" [companyName]="offer().company.name"
                [productName]="offer().card.productName" [variant]="'tc'" />
            </div>
          </div>
        </div>
        <div class="col-md-8 col-12 card-offer__info-col">
          <app-offer-info-molecule [receiveValue]="offer().card.offerValue ?? ''"
            [detail1Title]="offer().card.offerDetail1" [detail1Value]="offer().card.offerDetail1value"
            [approxTitle]="offer().card.offerAproxValueTitle ?? ''" [captionValue]="offer().card.offerAproxValue ?? ''"
            [additionalBenefits]="false" />
        </div>
      </div>
      <div class="card-lower-content">
      <div class="card-benefit-row" [class.card-benefit-row--empty]="!hasAdditionalBenefits()">
        @if (hasAdditionalBenefits()) {
        <app-ui-benefit-badge [showCrown]="false" [text]="offer().detail.textAdditionalBenefits ?? ''" />
        }
      </div>
      <div class="card-actions">
        <button class="card-actions__details" type="button" (click)="detailPressed.emit()">
          Ver más detalles <span>+</span>
        </button>
        @if (buttonState() === 1) {
        <button class="btn-cta" type="button" (click)="applyPressed.emit()">
          Aplicar ahora<i class="fa fa-chevron-right"></i>
        </button>
        }
        @if (buttonState() === 2 && !continueLoading()) {
        <button (click)="retryPressed.emit()" class="btn-cta blue">Retomar aplicación<i class="fa fa-chevron-right"></i></button>
        }
        @if (buttonState() === 2 && continueLoading()) {
        <button class="btn-cta blue spinner-btn"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>
        }
        @if (buttonState() === 3) {
        <button class="btn-cta">Oferta aplicada</button>
        }
      </div>
      </div>
    </div>
  </div>
</div>
}
<!--/NORMAL TC-->

<!--PRESELECTA-->
@if (type() === 'normal' && hasPreselecta()) {
<div class="box-card box-preselecta col-12" [id]="'offer' + labelId()">
  <div class="row">
    <p class="id-offer-hidden">{{ offer().idOffer }}</p>
    <div class="col-md-11 col-12">
      <div class="main-info row">
        <div class="col-md-4 col-12 d-flex d-md-none align-items-center justify-content-around">
          <p class="title-box-preselecta">¿Cómo finalizar tu solicitud?</p>
          <button class="btn-cta blue" (click)="continuePressed.emit()">Continuar la aplicación<i
              class="fa fa-chevron-right"></i></button>
        </div>
        <div class="col-12 d-none d-md-block">
          <p class="title-box-preselecta">¿Cómo finalizar tu solicitud?</p>
          <p class="desc-box-preselecta">Te enviaremos a la página de <b>{{ offer().company.name }}</b> para que
            finalices tu solicitud con breve registro.</p>
          <button class="btn-cta blue" (click)="continuePressed.emit()">Continuar la aplicación<i
              class="fa fa-chevron-right"></i></button>
        </div>
        <div class="col-12 d-none d-md-block">
          <div class="data-preselecta">
            <div>
              <p class="title-data-preselecta">Estado:</p>
              <p class="value-data-preselecta">Pendiente</p>
            </div>
            <div>
              <p class="title-data-preselecta">Referencia:</p>
              <p class="value-data-preselecta">{{ offer().preselecta.orderNumber }}</p>
            </div>
            <div>
              <p class="title-data-preselecta">Fecha:</p>
              <p class="value-data-preselecta">{{ offer().preselecta.date }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-10 col-md-12">
          <div class="col-12 d-block d-md-none no-margin-r no-padding-r">
            <hr />
            <p class="desc-box-preselecta">Te enviaremos a la página de <b>{{ offer().company.name }}</b> para que
              finalices tu solicitud con breve registro.</p>
          </div>
          <div class="col-12 d-block d-md-none no-margin-r no-padding-r">
            <div class="data-preselecta">
              <div class="first">
                <p class="title-data-preselecta">Estado:</p>
                <p class="value-data-preselecta">Pendiente</p>
              </div>
              <div>
                <p class="title-data-preselecta">Referencia:</p>
                <p class="value-data-preselecta">{{ offer().preselecta.orderNumber }}</p>
              </div>
              <div>
                <p class="title-data-preselecta">Fecha:</p>
                <p class="value-data-preselecta">{{ offer().preselecta.date }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2 d-flex d-md-none text-center">
          <button class="btn-more" (click)="clearPreselecta.emit()">+</button>
        </div>
      </div>
    </div>
    <div class="col-1 d-none d-md-flex">
      <button class="btn-more" (click)="clearPreselecta.emit()">+</button>
    </div>
  </div>
</div>
}
<!--/PRESELECTA-->

<!--APLICATION-->
@if (type() === 'aplication') {
<div class="tab blue">
  <h2 class="txtTab"><b>{{ applied().companyName }}</b> - {{ applied().productName }}</h2>
</div>
<div class="box-card-apli">
  @if (!showRating()) {
  <div class="content-offer content-apli">
    <div class="logoCompany logo-apli">
      <img src="{{ applied().entityimg }}" alt="{{ applied().companyName }}" title="{{ applied().productName }}" />
    </div>
    <div class="valueCompany value-apli">
      <h5>Ref. de Radicado:</h5>
      <p>{{ applied().orderNumber }}</p>
      <h5>Fecha radicado</h5>
      <p>{{ applied().applyDate | date:'dd MMM yyyy' }}</p>
      <h5>Estado</h5>
      <p [ngClass]="stateClass()">{{ applied().status }}</p>
    </div>
    <div class="card-actions">
      <button class="card-actions__details" type="button" (click)="showRating.set(true)">
        Ver más detalles <span>+</span>
      </button>
    </div>
  </div>
  }
  @if (showRating()) {
  <app-offer-rating-molecule [switchId]="switchId()"
    (ratingSubmit)="ratingSubmitted.emit($event); showRating.set(false)" (cancel)="showRating.set(false)" />
  }
  @if (ratingResult() === 'ok') {
  <div class="alert alert-success alert-dismissible" role="alert">
    <strong>Calificacion enviada con exito.</strong>
    <button type="button" class="close" (click)="alertClosed.emit()" aria-label="Close"><span
        aria-hidden="true">&times;</span></button>
  </div>
  }
  @if (ratingResult() === 'error') {
  <div class="alert alert-danger alert-dismissible" role="alert">
    <strong>Error al enviar la calificacion.</strong>
    <button type="button" class="close" (click)="alertClosed.emit()" aria-label="Close"><span
        aria-hidden="true">&times;</span></button>
  </div>
  }
</div>
}
<!--/APLICATION-->

<!--NUEVA NON-TC-->
@if (type() === 'nueva' && !cardForTC() && !hasPreselecta()) {
<div class="new-box">
  <div class="tab" [ngClass]="[labelConfig().color, labelConfig().showLabel ? 'tab--with-badge' : '']">
    <div class="tab-title-window" [class.tab-title-window--marquee]="tabTitleIsLong()">
      <h2 class="txtTab"><span>{{ tabTitle() }}</span></h2>
    </div>
    @if (labelConfig().showLabel) {
    <img class="tab-badge-icon" [src]="labelConfig().img" [alt]="offer().textLabel" [title]="offer().textLabel" />
    }
  </div>
  <div class="info-offer" [ngClass]="labelConfig().color">
    <div class="head-info">
      <div class="img-">
        <app-offer-media [logoUrl]="logoUrl()" [companyName]="offer().company.name"
          [productName]="offer().card.productName" />
      </div>
      <div><button type="button" (click)="detailPressed.emit()">Ver más detalles&nbsp;&nbsp;+</button></div>
    </div>
    <div class="body-info">
      <app-offer-info-molecule mainLabel="Recibes:" [receiveValue]="offer().card.offerValue ?? ''"
        [approxTitle]="offer().card.offerAproxValueTitle ?? ''" [captionValue]="offer().card.offerAproxValue ?? ''"
        [additionalBenefits]="offer().detail.additionalBenefits ?? false"
        [benefitsText]="offer().detail.textAdditionalBenefits ?? ''" [benefitBadgeLayout]="'new'" [showCrown]="false" />
    </div>
  </div>
</div>
}
<!--/NUEVA NON-TC-->

<!--NUEVA TC-->
@if (type() === 'nueva' && cardForTC() && !hasPreselecta()) {
<div class="new-box">
  <div class="tab" [ngClass]="[labelConfig().color, labelConfig().showLabel ? 'tab--with-badge' : '']">
    <div class="tab-title-window" [class.tab-title-window--marquee]="tabTitleIsLong()">
      <h2 class="txtTab"><span>{{ tabTitle() }}</span></h2>
    </div>
    @if (labelConfig().showLabel) {
    <img class="tab-badge-icon" [src]="labelConfig().img" [alt]="offer().textLabel" [title]="offer().textLabel" />
    }
  </div>
  <div class="info-offer info-tc" [ngClass]="labelConfig().color">
    <div class="tc-media-slot">
      <app-offer-media [logoUrl]="logoUrl()" [companyName]="offer().company.name"
        [productName]="offer().card.productName" [variant]="'tc'" />
    </div>
    <div class="body-info">
      <div class="section-info-tc">
        <app-offer-info-molecule mainLabel="Recibes:" [receiveValue]="offer().card.offerValue ?? ''"
          [approxTitle]="offer().card.offerAproxValueTitle ?? ''" [captionValue]="offer().card.offerAproxValue ?? ''" />
      </div>
      <div class="section-info-tc">
        <button type="button" (click)="detailPressed.emit()">Ver más detalles&nbsp;&nbsp;+</button>
      </div>
    </div>
    <div class="add-benefit">
      <div><img title="crown" class="crown" alt="corona-beneficio" src="assets/icons/Icono_corona_adicional.svg" />
      </div>
      <div>
        <p>Al aplicar a esta oferta recibes: Una tarjeta de regalo de Netflix.</p>
      </div>
    </div>
  </div>
</div>
}
<!--/NUEVA TC-->

}